import { useAccountInfoContext } from '../../../services/account-data-service';
import { BodyText } from '@block-explorer/ui';
import { FlexRow } from '@make-software/cspr-ui';
import { AccountInfoIcon } from '../../account-info-icon/account-info-icon';
import React from 'react';
import { AccountInfoResult, Deploy } from '@block-explorer/entities';
import { buildRouterPath } from '../../../router/utils';
import { ACCOUNT_DETAILS_PATH } from '../../../router/paths';
import { deriveAccountInfo, isValidPublicKey } from '../../../utils/account';

export const TransferActionMessage = ({
  deploy,
  isHome,
  showOnlyActionName = false,
}: {
  deploy: Deploy;
  isHome?: boolean;
  showOnlyActionName?: boolean;
}) => {
  const { getAccountInfo, getPublicKeyAccountHash } = useAccountInfoContext();

  const recipientKey = deploy.args.target?.parsed as string;
  const isRecipientKeyValidPublicKey =
    recipientKey && isValidPublicKey(recipientKey);

  const recipientPublicKey = isRecipientKeyValidPublicKey
    ? recipientKey
    : getPublicKeyAccountHash(recipientKey);

  const callerPublicKey = deploy.callerPublicKey || deploy.callerHash;

  const callerInfo = getAccountInfo<AccountInfoResult>(callerPublicKey);
  const recipientInfo = getAccountInfo<AccountInfoResult>(
    recipientPublicKey || ''
  );

  const callerLogo =
    callerInfo &&
    deriveAccountInfo(
      callerInfo.account_info || callerInfo.centralized_account_info
    )?.logo;

  const recipientLogo =
    recipientInfo &&
    deriveAccountInfo(
      recipientInfo.account_info || recipientInfo.centralized_account_info
    )?.logo;

  const callerCsprName = callerInfo?.cspr_name;
  const recipientCsprName = recipientInfo?.cspr_name;

  const callerAccountPath = callerPublicKey
    ? buildRouterPath(ACCOUNT_DETAILS_PATH, { id: callerPublicKey }, undefined)
    : '';

  const recipientAccountPath =
    recipientPublicKey || recipientKey
      ? buildRouterPath(
          ACCOUNT_DETAILS_PATH,
          { id: recipientPublicKey || recipientKey },
          undefined
        )
      : '';

  return (
    <FlexRow align={'baseline'} itemsSpacing={4}>
      <BodyText monotype size={3}>
        Transfer
      </BodyText>
      {!showOnlyActionName && callerPublicKey && isHome ? (
        <FlexRow itemsSpacing={6} align={'center'}>
          <BodyText size={3} variation={'darkGray'}>
            from{' '}
          </BodyText>{' '}
          <AccountInfoIcon
            publicKey={callerPublicKey}
            csprName={callerCsprName}
            logo={callerLogo || null}
            path={callerAccountPath}
          />{' '}
        </FlexRow>
      ) : null}
      {!showOnlyActionName && (recipientPublicKey || recipientKey) ? (
        <FlexRow itemsSpacing={6} align={'center'}>
          <BodyText size={3} variation={'darkGray'}>
            to{' '}
          </BodyText>{' '}
          <AccountInfoIcon
            publicKey={recipientPublicKey || recipientKey}
            csprName={recipientCsprName}
            logo={recipientLogo || null}
            path={recipientAccountPath}
          />{' '}
        </FlexRow>
      ) : null}
    </FlexRow>
  );
};
